// "NOVOSTI" where the letters "OS" are the logo's two linked rings (blue and black), as on the client's drawings.
// The ring mark is the first part of the site logo, cut out (public/novosti-mark.png); the letters are text.
export default function NovostiLinkLabel() {
  return (
    <span className="inline-flex items-center font-light uppercase leading-none tracking-[0.04em]" aria-label="Novosti">
      <span aria-hidden="true">Nov</span>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/novosti-mark.png" alt="" aria-hidden="true" className="mx-[0.04em] h-[0.82em] w-auto" />
      <span aria-hidden="true">ti</span>
    </span>
  );
}
